import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {DocumentosService} from '~core/api/documentos.service';
import {ArquivoRecibo, LinkVo} from '~entity/entity-documento/entity-documento.model';

@Component({
  selector: 'app-rota-detalhes-recibos',
  templateUrl: './rota-detalhes-recibos.component.html',
  styleUrls: ['./rota-detalhes-recibos.component.scss'],
  providers: [DocumentosService],
})
export class RotaDetalhesRecibosComponent implements OnInit {
  @Input() loaded$!: BehaviorSubject<boolean>;
  @Input() recibos$!: BehaviorSubject<(ArquivoRecibo & LinkVo & {data: Date})[]>;
  @Input() adiantamento$!: BehaviorSubject<number>;
  @Input() despesas$!: BehaviorSubject<number>;
  @Output() downloadFile$: EventEmitter<ArquivoRecibo> = new EventEmitter();

  ngOnInit(): void {
    this.recibos$.pipe(debounceTime(250)).subscribe(d => {
      d.sort((a, b) => {
        return a.timestamp - b.timestamp;
      });
    });
  }

  download(arquivo: ArquivoRecibo): void {
    this.downloadFile$.emit(arquivo);
  }
}
